import type { ELK } from "elkjs/lib/elk-api";

let elkPromise: Promise<ELK> | null = null;

/**
 * Lazily loads elkjs (heavy graph-layout bundle) so it stays out of the
 * main chunk; only the Ownership canvas pulls it in.
 */
export function getElk(): Promise<ELK> {
    elkPromise ??= import("elkjs/lib/elk.bundled.js")
        .then((module) => new module.default())
        .catch((error) => {
            elkPromise = null;
            throw error;
        });
    return elkPromise;
}
